<div class="col-sm-12" id="pgmJourFerie" style="height: 100%; padding: 5px 0;">
  <div class="fiche col-sm-12" style="padding: 2px 20px 5px 20px;">
    <div class="text-right col-sm-12 pull-right" style="padding-right: 0;">
      <div class="col-sm-7 fiche-client">
        <div> Gestion de l'équipe </div>

      </div>
      <button class="uppercase" id="savecont" *ngIf="!isHistoLoc" (click)="saveFct()"> Enregistrer </button>
      <button class="uppercase btn-close" id="closeclt" (click)="fermer()"> Fermer </button>
    </div>
  </div>
  <div class="contente ligneBon col-sm-12" style="color: #000;padding: 15px 15px 5px; font-size: 13px;">
    <div class="col-sm-12" style="padding: 0; height: 100%;">
      <div class="col-sm-12" style="padding: 0px; height: 100%;">
        <div class="form-group items col-sm-12" style="padding:0px">
          <label class="col-sm-5 champ" style="padding:0px">
            Poste Leader :
          </label>
          <div class="col-sm-7 champ" style="padding-right: 0px">
            <app-autocomplete [placeholder]="''" [results]="dataQualificationTrue" [label]="''" [isCombo]="true"
              id="modedepaie" (selectfunction)="objEquipe.qualificationLeader = $event;"
              [defaultselected]="objEquipe.qualificationLeader" [container]="true" [disablefocus]="true"
              [highlight]="true" (searchfunction)="searchQualification(true)" [dropdownclass]="'maxZindex'"
              [defaultsearch]="(objEquipe.qualificationLeader ? (objEquipe.qualificationLeader.libelleObjetEntite) : '')">
            </app-autocomplete>
          </div>
        </div>
        <div class="form-group items col-sm-12" style="padding:0px" *ngIf="objEquipe.program"
          [ngClass]="{'disabledbutton': !objEquipe.program || isHistoLoc}">
          <label class="col-sm-5 champ" style="padding:0px">
            Pers. par défaut (Leader) :
          </label>
          <div class="col-sm-7 champ" style="padding-right: 0px">
            <app-autocomplete [placeholder]="''" [results]="listPersodefault" [label]="''" 
              [dropdownclass]="'maxZindex'" (selectfunction)="selectedChauffeurParDefaut(objEquipe, 'leaderEquipe', $event);"
              [defaultselected]="objEquipe.leaderEquipe" [showResultKeyenter]="true" [container]="true"
              [disablefocus]="true" [selectvalue]="true"  [actualise]="true"
              (searchfunction)="selectchauff(objEquipe.leaderEquipe);searchPersodefault($event, objEquipe.qualificationLeader)"
              [defaultsearch]="(objEquipe.leaderEquipe && objEquipe.leaderEquipe.id ? (objEquipe.leaderEquipe.libelleObjetEntite || 'A définir') : 'A définir')">
            </app-autocomplete>
          </div>
        </div>
        <div class="form-group items col-sm-12" style="padding:0px" [ngClass]="{'disabledbutton': isHistoLoc}">
          <label class="col-sm-5 champ" style="padding:0px">
            Pers. ponctuel (Leader) :
          </label>
          <div class="col-sm-7 champ" style="padding-right: 0px">
            <app-autocomplete [placeholder]="''" [results]="listPersoPonctuel" [label]="''" 
            [showResultKeyenter]="true" id="modedepaie"
              (selectfunction)="objEquipe.changeChauff = true; selectedChauffeurPonctuel(objEquipe, 'chauffeur', $event);"
              [defaultselected]="objEquipe.chauffeur" [dropdownclass]="'maxZindex'" [container]="true"
               [id] = "'persPonct'" [disablefocus] = "true" [selectvalue] = "true" [actualise]="true"
              (searchfunction)="selectchauff(objEquipe.chauffeur);searchPersoPonctuel($event, objEquipe.qualificationLeader)"
              [defaultsearch]="(objEquipe.chauffeur && objEquipe.chauffeur.id ? (objEquipe.chauffeur.libelleObjetEntite || 'A définir') : 'A définir')">
            </app-autocomplete>
          </div>
        </div>
        <div class="form-group items col-sm-12" style="padding:0px" *ngIf="objEquipe.program"
          [ngClass]="{'disabledbutton': isHistoLoc}">
          <label class="col-sm-5 champ" style="padding:0px">
            Lieu de tra. par défaut :
          </label>
          <div class="col-sm-7 champ" style="padding-right: 0px">
            <app-autocomplete [placeholder]="''" [results]="listLieu" [label]="''" [isCombo]="true" id="modedepaie"
              (selectfunction)="objEquipe.lieuChantierParDefaut = $event;"
              [defaultselected]="objEquipe.lieuChantierParDefaut" [container]="true" [disablefocus]="true"
              (searchfunction)="searchQualification(true)" [dropdownclass]="'maxZindex'"
              [defaultsearch]="(objEquipe.lieuChantierParDefaut ? (objEquipe.lieuChantierParDefaut.libelleObjetEntite || objEquipe.lieuChantierParDefaut.nom) : 'Non spécifié')">
            </app-autocomplete>
          </div>
        </div>
        <div class="form-group items col-sm-12" style="padding:0px" [ngClass]="{'disabledbutton': isHistoLoc}">
          <label class="col-sm-5 champ" style="padding:0px">
            Lieu de tra. :
          </label>
          <div class="col-sm-7 champ" style="padding-right: 0px">
            <app-autocomplete [placeholder]="''" [results]="listLieu" [label]="''" [isCombo]="true" id="modedepaie"
              (selectfunction)="objEquipe.lieuChantier = $event;" [defaultselected]="objEquipe.lieuChantier"
              [container]="true" [disablefocus]="true" (searchfunction)="searchQualification(true)"
              [dropdownclass]="'maxZindex'"
              [defaultsearch]="(objEquipe.lieuChantier ? (objEquipe.lieuChantier.libelleObjetEntite || objEquipe.lieuChantier.nom) : 'Non spécifié')">
            </app-autocomplete>
          </div>
        </div>
        <div class="form-group items col-sm-12" style="padding:0px" *ngIf="objEquipe.program"
          [ngClass]="{'disabledbutton': isHistoLoc}">
          <label class="col-sm-5 champ" style="padding:0px">
            Lieu de dép. par défaut :
          </label>
          <div class="col-sm-7 champ" style="padding-right: 0px">
            <app-autocomplete [placeholder]="''" [results]="listLieuDepart" [label]="''" [isCombo]="true"
              id="modedepaie" (selectfunction)="objEquipe.lieuDepartParDefaut = $event;"
              [defaultselected]="objEquipe.lieuDepartParDefaut" [container]="true" [disablefocus]="true"
              (searchfunction)="searchQualification(true)" [dropdownclass]="'maxZindex'"
              [defaultsearch]="(objEquipe.lieuDepartParDefaut ? (objEquipe.lieuDepartParDefaut.libelleObjetEntite) : 'Non spécifié')">
            </app-autocomplete>
          </div>
        </div>
        <div class="form-group items col-sm-12" style="padding:0px" [ngClass]="{'disabledbutton': isHistoLoc}">
          <label class="col-sm-5 champ" style="padding:0px">
            Lieu de départ :
          </label>
          <div class="col-sm-7 champ" style="padding-right: 0px">
            <app-autocomplete [placeholder]="''" [results]="listLieuDepart" [label]="''" [isCombo]="true"
              id="modedepaie" (selectfunction)="objEquipe.lieuDepart = $event;" [defaultselected]="objEquipe.lieuDepart"
              [container]="true" [disablefocus]="true" (searchfunction)="searchQualification(true)"
              [dropdownclass]="'maxZindex'"
              [defaultsearch]="(objEquipe.lieuDepart ? (objEquipe.lieuDepart.libelleObjetEntite) : 'Non spécifié')">
            </app-autocomplete>
          </div>
        </div>
        <div class="addLigne col-sm-12 uppercase" [ngClass]="{'disabledbutton': isHistoLoc}">
          <div class="col-sm-7 text-left">
            <button class="btn-add" id="addLigne" (click)="clickAddPost()">
              <i class="fa fa-plus"></i>
            </button>
            <span style="padding: 0 10px;" (click)="clickAddPost()">Ajouter
              poste</span>

          </div>
          <h5 class="text-right uppercase col-sm-5"> Equipiers</h5>
        </div>
        <div class="col-sm-12 ligneBon liste" style="height: calc(100% - 335px);padding: 0px;">
          <ngx-datatable style="height: 100%" class="material" [rows]="listePersonnelParPoste()" [columnMode]="'force'"
            [headerHeight]="35" [footerHeight]="0" [selectionType]="'checkbox'" [rowHeight]="'auto'"
            [messages]="{emptyMessage: 'Pas de lignes à afficher'}" [loadingIndicator]="loadingIndicator">

            <ngx-datatable-column name="Chantier" prop="poste.qualification.libelleObjetEntite"
              [cellClass]="getCellClass">
              <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn"
                let-sort="sortFn">
                <div class="tableheader text-left">
                  <span class="uppercase"> Poste </span>
                </div>
              </ng-template>
              <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                {{ value }}
              </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column name="Chantier" prop="agence.libelle" [width]="300">
              <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn"
                let-sort="sortFn">
                <div class="tableheader">
                  <span class="uppercase"> Personnel </span>
                </div>
              </ng-template>
              <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                <div class="col-sm-12 personnelEquipeEcoloc p-0">
                  <div class="col-sm-12 p-0 " *ngIf="objEquipe.program"
                    [ngClass]="{'disabledbutton': !objEquipe.program || isHistoLoc}" style="margin-bottom: 4px;">
                    <app-autocomplete [placeholder]="''" (selectfunction)="selectedChauffeurParDefaut(row, 'personnelDefaut', $event);"
                      [results]="listPersodefault" [label]="'Par defaut :'" [defaultselected]="row.personnelDefaut"
                      [container]="true" [showResultKeyenter]="true"  [actualise]="true"
                      [id]="'detailfact btncombo personnelDefaut' + rowIndex" [disablefocus]="true"
                      [dropdownclass]="'maxZindex'" [selectvalue]="true"
                      (searchfunction)="selectchauff(row.personnelDefaut);searchPersodefault($event, row.poste)"
                      [defaultsearch]="(row.personnelDefaut && row.personnelDefaut.id ? (row.personnelDefaut.libelleObjetEntite || 'A définir') : 'A définir')">
                    </app-autocomplete>
                  </div>
                  <div class="col-sm-12 p-0" style="margin-bottom: 4px;">
                    <app-autocomplete [ngClass]="{'disabledbutton': isHistoLoc}" [placeholder]="''"
                      (selectfunction)="selectedChauffeurPonctuel(row, 'chauffeur', $event);" [results]="listPersoPonctuel" [label]="'Ponctuel :'"
                      [defaultselected]="row.chauffeur" [selectvalue]="true" [container]="true"
                      [id]="'detailfact btncombo chauffeur' + rowIndex" [showResultKeyenter]="true"
                      [disablefocus]="true" [dropdownclass]="'maxZindex'"  [actualise]="true"
                      (searchfunction)="selectchauff(row.chauffeur);searchPersoPonctuel($event, row.poste)"
                      [defaultsearch]="(row.chauffeur && row.chauffeur.id ? (row.chauffeur.libelleObjetEntite || 'A définir') : 'A définir')">
                    </app-autocomplete>
                  </div>

                </div>
              </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column name="Chantier" prop="agence.libelle">
              <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn"
                let-sort="sortFn">
                <div class="tableheader">
                  <span class="uppercase"> Lieu travail </span>
                </div>
              </ng-template>
              <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                <div class="col-sm-12 lieuEquipeEcoloc p-0">
                  <div class="col-sm-12 p-0" *ngIf="objEquipe.program"
                    [ngClass]="{'disabledbutton': !objEquipe.program || isHistoLoc}" style="margin-bottom: 4px;">
                    <app-autocomplete [placeholder]="''" (selectfunction)="row.lieuChantierParDefaut = $event;"
                      [isCombo]="true" [results]="listLieu" [label]="'Par defaut :'"
                      [defaultselected]="row.lieuChantierParDefaut" [container]="true" [showResultKeyenter]="true"
                      [id]="'detailfact btncombo lieuChantierParDefaut' + rowIndex" [disablefocus]="true"
                      [dropdownclass]="'maxZindex'" [selectvalue]="true"
                      [defaultsearch]="(row.lieuChantierParDefaut ? (row.lieuChantierParDefaut.libelleObjetEntite || row.lieuChantierParDefaut.nom || 'Non spécifié') : 'Non spécifié')">
                    </app-autocomplete>
                  </div>
                  <div class="col-sm-12 p-0" [ngClass]="{'disabledbutton': isHistoLoc}">
                    <app-autocomplete [placeholder]="''" (selectfunction)="row.lieuChantier = $event;" [isCombo]="true"
                      [results]="listLieu" [label]="'Ponctuel :'" [defaultselected]="row.lieuChantier" [container]="true"
                      [showResultKeyenter]="true" [id]="'detailfact btncombo lieuChantier' + rowIndex"
                      [disablefocus]="true" [dropdownclass]="'maxZindex'" [selectvalue]="true"
                      [defaultsearch]="(row.lieuChantier ? (row.lieuChantier.libelleObjetEntite || row.lieuChantier.nom || 'Non spécifié') : 'Non spécifié')">
                    </app-autocomplete>
                  </div>

                </div>
              </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column name="Chantier" prop="agence.libelle">
              <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn"
                let-sort="sortFn">
                <div class="tableheader">
                  <span class="uppercase"> Lieu départ </span>
                </div>
              </ng-template>
              <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                <div class="col-sm-12 lieuDepEquipeEcoloc p-0">
                  <div class="col-sm-12 p-0" *ngIf="objEquipe.program"
                    [ngClass]="{'disabledbutton': !objEquipe.program || isHistoLoc}" style="margin-bottom: 4px;">
                    <app-autocomplete [placeholder]="''" (selectfunction)="row.lieuDepartParDefaut = $event;"
                      [isCombo]="true" [results]="listLieuDepart" [label]="'Par defaut :'"
                      [defaultselected]="row.lieuDepartParDefaut" [container]="true" [showResultKeyenter]="true"
                      [id]="'detailfact btncombo lieuDepartParDefaut' + rowIndex" [disablefocus]="true"
                      [dropdownclass]="'maxZindex'" [selectvalue]="true"
                      [defaultsearch]="(row.lieuDepartParDefaut ? (row.lieuDepartParDefaut.libelleObjetEntite || 'Non spécifié') : 'Non spécifié')">
                    </app-autocomplete>
                  </div>
                  <div class="col-sm-12 p-0" [ngClass]="{'disabledbutton': isHistoLoc}">
                    <app-autocomplete [placeholder]="''" (selectfunction)="row.lieuDepart = $event;" [isCombo]="true"
                      [results]="listLieuDepart" [label]="'Ponctuel :'" [defaultselected]="row.lieuDepart" [container]="true"
                      [showResultKeyenter]="true" [id]="'detailfact btncombo lieuDepart' + rowIndex"
                      [disablefocus]="true" [dropdownclass]="'maxZindex'" [selectvalue]="true"
                      [defaultsearch]="(row.lieuDepart ? (row.lieuDepart.libelleObjetEntite || 'Non spécifié') : 'Non spécifié')">
                    </app-autocomplete>
                  </div>

                </div>
              </ng-template>
            </ngx-datatable-column>
            <!-- <ngx-datatable-column name="Chantier" prop="agence.libelle" [width]="200">
              <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn"
                let-sort="sortFn">
                <div class="tableheader">
                  <span class="uppercase"> Pers. par défaut </span>
                </div>
              </ng-template>
              <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                <div [ngClass]="{'disabledbutton': !objEquipe.program || isHistoLoc}">
                  <app-autocomplete [placeholder]="''" (selectfunction)="row.personnelDefaut = $event;"
                    [results]="listPersodefault" [label]="''" [defaultselected]="row.personnelDefaut" [container]="true"
                    [showResultKeyenter]="true" [id]="'detailfact btncombo personnelDefaut' + rowIndex"
                    [disablefocus]="true" [dropdownclass]="'maxZindex'" [selectvalue]="true" 
                    (searchfunction)="searchPersodefault($event, row.poste)"
                    [defaultsearch]="(row.personnelDefaut ? (row.personnelDefaut.libelleObjetEntite || 'A définir') : 'A définir')">
                  </app-autocomplete>
                </div>
              </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column name="Chantier" prop="agence.libelle">
              <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn"
                let-sort="sortFn">
                <div class="tableheader">
                  <span class="uppercase"> Lieu tra. par déf. </span>
                </div>
              </ng-template>
              <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                <div   [ngClass]="{'disabledbutton': isHistoLoc}">
                  <app-autocomplete [placeholder]="''" (selectfunction)="row.lieuChantierParDefaut = $event;" [isCombo]="true"
                    [results]="listLieu" [label]="''" [defaultselected]="row.lieuChantierParDefaut" [container]="true"
                    [showResultKeyenter]="true" [id]="'detailfact btncombo lieuChantierParDefaut' + rowIndex"
                    [disablefocus]="true" [dropdownclass]="'maxZindex'" [selectvalue]="true"
                    [defaultsearch]="(row.lieuChantierParDefaut ? (row.lieuChantierParDefaut.libelleObjetEntite || row.lieuChantierParDefaut.nom || 'Non spécifié') : 'Non spécifié')">
                  </app-autocomplete>
                </div>
              </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column name="Chantier" prop="agence.libelle">
              <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn"
                let-sort="sortFn">
                <div class="tableheader">
                  <span class="uppercase"> Lieu dép. par déf. </span>
                </div>
              </ng-template>
              <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                <div   [ngClass]="{'disabledbutton': isHistoLoc}">
                  <app-autocomplete [placeholder]="''" (selectfunction)="row.lieuDepartParDefaut = $event;" [isCombo]="true"
                    [results]="listLieuDepart" [label]="''" [defaultselected]="row.lieuDepartParDefaut" [container]="true"
                    [showResultKeyenter]="true" [id]="'detailfact btncombo lieuDepartParDefaut' + rowIndex"
                    [disablefocus]="true" [dropdownclass]="'maxZindex'" [selectvalue]="true"
                    [defaultsearch]="(row.lieuDepartParDefaut ? (row.lieuDepartParDefaut.libelleObjetEntite || 'Non spécifié') : 'Non spécifié')">
                  </app-autocomplete>
                </div>
              </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column name="Chantier" prop="chauffeur.libelle" [width]="200">
              <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn"
                let-sort="sortFn">
                <div class="tableheader">
                  <span class="uppercase"> Pers. ponctuel </span>
                </div>
              </ng-template>
              <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                <app-autocomplete   [ngClass]="{'disabledbutton': isHistoLoc}" [placeholder]="''" (selectfunction)="row.chauffeur = $event;"
                  [results]="listPersoPonctuel" [label]="''" [defaultselected]="row.chauffeur" [selectvalue]="true"
                  [container]="true" [id]="'detailfact btncombo chauffeur' + rowIndex" [showResultKeyenter]="true"
                  [disablefocus]="true" [dropdownclass]="'maxZindex'"
                  (searchfunction)="searchPersoPonctuel($event, row.poste)"
                  [defaultsearch]="(row.chauffeur ? (row.chauffeur.libelleObjetEntite || 'A définir') : 'A définir')">
                </app-autocomplete>
              </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column name="Chantier" prop="agence.libelle">
              <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn"
                let-sort="sortFn">
                <div class="tableheader">
                  <span class="uppercase"> Lieu tra.</span>
                </div>
              </ng-template>
              <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                <div   [ngClass]="{'disabledbutton': isHistoLoc}">
                  <app-autocomplete [placeholder]="''" (selectfunction)="row.lieuChantier = $event;" [isCombo]="true"
                    [results]="listLieu" [label]="''" [defaultselected]="row.lieuChantier" [container]="true"
                    [showResultKeyenter]="true" [id]="'detailfact btncombo lieuChantier' + rowIndex"
                    [disablefocus]="true" [dropdownclass]="'maxZindex'" [selectvalue]="true" 
                    [defaultsearch]="(row.lieuChantier ? (row.lieuChantier.libelleObjetEntite || row.lieuChantier.nom || 'Non spécifié') : 'Non spécifié')">
                  </app-autocomplete>
                </div>
              </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column name="Chantier" prop="agence.libelle">
              <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn"
                let-sort="sortFn">
                <div class="tableheader">
                  <span class="uppercase"> Lieu dép. </span>
                </div>
              </ng-template>
              <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                <div   [ngClass]="{'disabledbutton': isHistoLoc}">
                  <app-autocomplete [placeholder]="''" (selectfunction)="row.lieuDepart = $event;" [isCombo]="true"
                    [results]="listLieuDepart" [label]="''" [defaultselected]="row.lieuDepart" [container]="true"
                    [showResultKeyenter]="true" [id]="'detailfact btncombo lieuDepart' + rowIndex"
                    [disablefocus]="true" [dropdownclass]="'maxZindex'" [selectvalue]="true" 
                    [defaultsearch]="(row.lieuDepart ? (row.lieuDepart.libelleObjetEntite || 'Non spécifié') : 'Non spécifié')">
                  </app-autocomplete>
                </div>
              </ng-template>
            </ngx-datatable-column> -->
            <ngx-datatable-column [width]="50" [sortable]="false" [canAutoResize]="false" [draggable]="false"
              [resizeable]="false">
              <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-row="row">
                <div class="text-center" [ngClass]="{'disabledbutton': isHistoLoc}"><button class="btn-detail"
                    (click)="selectedPoste = row; common.openModal(modalService, confirmeSuppPoste)">
                    <i class="fa fa-trash"></i>
                  </button></div>
              </ng-template>
            </ngx-datatable-column>
          </ngx-datatable>
        </div>
      </div>


    </div>
  </div>
</div>


<ng-template #msg>
  <div class="modal-body" style="height: auto">
    <div>
      <div class="col-sm-12">
        <strong class="cofirmemsg"> {{ error }} </strong>
      </div>
    </div>
    <div class="text-right" style="margin-top: 15px;">
      <button type="button" class=" btn-close btn-valider" (click)="common.closeModal()"> Fermer </button>
    </div>
  </div>
</ng-template>

<ng-template #qualificationTemp>
  <div class="modal-header">
    <h4 class="modal-title pull-left"  >Sélectionner la qualification </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="common.closeModal()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body" style="height: auto">
    <div >
      <app-autocomplete [placeholder]="'Qualification'" (searchfunction)="searchQualification()"
        (selectfunction)="selectedQual = $event"  [ActiveFocusCombo]="true" [id] = "'qualifEquip'"  [results]="dataQualification"
        [defaultsearch]="selectedQual ? selectedQual.libelleObjetEntite : ''" [isCombo]="true">
      </app-autocomplete>
    </div>

    <div class="text-right" style="margin-top: 15px;">
      <button type="button" class=" btn-close btn-valider" *ngIf="selectedQual"
        (click)=" common.closeModal();addLigne();">
        OK </button>
      <button type="button" class=" btn-close" (click)="common.closeModal()"> Annuler </button>
    </div>
  </div>
</ng-template>

<ng-template #confirmeSuppPoste>
  <div class="modal-header">
    <h4 class="modal-title pull-left"> Confirmation </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="common.closeModal()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body" style="height: auto">
    <div>
      <div class="col-sm-12">
        <label class="cofirmemsg"> La suppresion du/des poste(s) sera effective sur tous les
          mouvement.</label>
        <label class="cofirmemsg"> Souhaitez vous réaliser cette opération ? </label>
      </div>
    </div>
    <div class="text-right" style="margin-top: 15px;">
      <button type="button" class=" btn-close btn-valider" (click)="common.closeModal();deleteLigne(selectedPoste);">
        OUI
      </button>
      <button type="button" class=" btn-close" (click)="common.closeModal()"> NON </button>
    </div>
  </div>
</ng-template>
